import React from 'react';
import _ from 'lodash';
import { Box, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { useResponsive } from '../../../services/hooks';

const SelectParticipant = ({ participants, setParticipantData, splitName = true }) => {
  const [participant, setParticipant] = React.useState('');
  const isDesktop = useResponsive('up', 'lg');

  const handleChange = e => {
    setParticipant(e.target.value);
    const participantData = _.find(participants, p => p.id === e.target.value);
    if (_.isNil(participantData)) {
      setParticipantData({});
    } else if (!_.isNil(participantData.name) && splitName) {
      const lastIndex = participantData.name.lastIndexOf(' ');
      const name = participantData.name.substr(0, lastIndex);
      const surname = participantData.name.substr(lastIndex + 1);
      const p = { ...participantData, name, surname };
      setParticipantData(p);
    } else {
      setParticipantData(participantData);
    }
  };

  return (
    <Box m={4} style={isDesktop ? { marginLeft: '5vw', marginRight: '5vw', padding: '16px 12px', borderRadius: '20px' } : { padding: '16px 10px', borderRadius: '20px' }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-standard-label">Uczestnik</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={participant}
          onChange={handleChange}
          label="Uczestnik"
          sx={{
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.light'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.dark'
            }
          }}
        >
          <MenuItem value="">
            <em>Wybierz</em>
          </MenuItem>
          {participants.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectParticipant;
